<div
  #container
  class="super-latex-container"
  [class.has-highlights]="highlight()"
  [ngStyle]="{
    'align-items': alignTextBlock() === 'left' ? 'flex-start' : alignTextBlock() === 'center' ? 'center' : 'flex-end'
  }"
>
  <div class="latex-lines-wrapper">
    @for (node of latexNodes(); track node.latex; let i = $index) {
      <div
        class="latex-line"
        [class]="node.custom_class ?? ''"
        [class.align-on-equals]="alignOnEquals()"
        [ngStyle]="lineStyles()[i]"
        [attr.data-node-key]="node.id ?? node.latex"
        [@itemStaggerAnimation]
      >
        <markdown [data]="node.latex" katex [katexOptions]="katexOptions" />
      </div>
    }
  </div>
  @for (target of annotationTargets(); track target.annotation.id) {
    <dojo-annotation-engine [annotation]="target.annotation" [targetElement]="target.element" />
  }
</div>
